import React, { PureComponent } from 'react';
import { filter } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { del as delContacts, get as getContacts } from '../../redux/modules/contacts';
import * as TextActions from '../../redux/modules/text';
import ListEntity from '../../components/ListEntity/List';
import Contact from '../../components/ListEntity/Entities/Contact';
import Modal from '../../components/Render/Modal/Modal';
import { ContactsForm } from '../../forms/index';
import GenericTextForm from '../../forms/generic-text/index';
import LayoutSection from '../../components/layout-section';
import TextSection from '../../components/ListEntity/TextSection';

class Contacts extends PureComponent {
  state = { isOpen: false };

  getData() {
    this.props.getAsync();
    this.props.getTextAction('contacts');
  }

  componentWillMount() {
    this.getData()
  }

  remove(info) {
    if (info.id > 0) {
      const { getAsync, delContacts } = this.props;
      delContacts(info.id).then(() => {
        getAsync();
      });
    }
  }

  toggleOpenModal(form = '', contactType = '', data = {}) {
    this.setState({ isOpen: !this.state.isOpen, form, contactType, data });
  }

  render() {
    const { contacts, text } = this.props;
    const social = filter(contacts, { 'type': 'social' });
    const general = filter(contacts, { 'type': 'general' });
    return (
      <div className="contacts-container container">

        <LayoutSection
          isFetching={text.isFetching}
          title="Contacts">
          <TextSection
            editAction={() => {
              this.toggleOpenModal('text', '', text.values);
            }}>
            <div dangerouslySetInnerHTML={{ __html: text.values.body }}></div>
          </TextSection>
        </LayoutSection>

        <div className="row">
          <h3>General</h3>
          <ListEntity
            component={Contact}
            removeAction={(index) => {
              this.remove(general[index])
            }}
            editAction={(index) => {
              this.toggleOpenModal('contact', 'general', general[index]);
            }}
            addAction={() => {
              this.toggleOpenModal('contact', 'general');
            }} values={general}/>
        </div>
        <div className="row">
          <h3>Social</h3>
          <ListEntity
            component={Contact}
            removeAction={(index) => {
              this.remove(social[index])
            }}
            editAction={(index) => {
              this.toggleOpenModal('contact', 'social', social[index]);
            }}
            addAction={() => {
              this.toggleOpenModal('contact', 'social');
            }} values={social}/>
        </div>

        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenModal.bind(this)}
            isOpen={this.state.isOpen}>
            {
              this.state.form === 'text' ?
                <GenericTextForm
                  numberOfImages={0}
                  section="contacts"
                  close={this.toggleOpenModal.bind(this)}
                  defaultValues={this.state.data}/> :
                <ContactsForm
                  defaultValues={this.state.data}
                  toogle={this.toggleOpenModal.bind(this)}
                  contactType={this.state.contactType}/>
            }
          </Modal>
        </div>
      </div>
    );
  }
}

Contacts.propTypes = {};
Contacts.defaultProps = {};

export default connect(
  (state) => {
    return {
      contacts: state.contacts.values,
      text: state.text,
    };
  },
  (dispatch) => {
    return bindActionCreators({ getAsync: getContacts, delContacts, getTextAction: TextActions.get }, dispatch);
  }
)(Contacts);



// WEBPACK FOOTER //
// ./src/containers/contacts/Contacts.js